module.exports = __webpack_public_path__ + "static/testimonial2-ceb27995ed94d9fc30575c4c34c386c9.svg";